<template lang="pug">
  .card
    header.card-header
      .columns.has-text-centered
        .column
          p.card-header-title
            small {{ device.tag}}
    .card-content
      .columns.is-hidden-mobile
        .column
          b
            i.fas.fa-tablet-alt
            | &nbspDescripción:
        .column
          span.card-content
            span.tag.is-black
              | {{ device.marca }} - {{ device.modelo }}
      .columns.is-hidden-mobile
        .column
          b
            i.fas.fa-barcode
            | &nbspSerie:
        .column
          span.card-content
            b 
              | {{ device.serie }}
      .columns.is-hidden-mobile
        .column
          b
            i.fas.fa-calendar-alt
            | &nbspVida útil
        .column
          span.card-content
            b 
              | {{ device.vidaUtil }}
      .columns.is-hidden-mobile
        .column
          b 
            i.fas.fa-map-marker-alt
            | &nbspUbicación
        .column
          span.card-content
            b 
              | {{ device.ubicacion }}
      .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
        b  
          i.fas.fa-tablet-alt
          | &nbspDescripción:
      .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
        span.card-content
          span.tag.is-black
            | {{ device.marca }} - {{ device.modelo }}
        hr
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          b  
            i.fas.fa-barcode
            | &nbspSerie:
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          span.card-content
            b 
              | {{ device.serie }}
          hr
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          b 
            i.fas.fa-calendar-alt
            | &nbspVida útil
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          span.card-content
            b 
              | {{ device.vidaUtil }}
          hr
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          b 
            i.fas.fa-map-marker-alt
            | &nbspUbicación
        .columns.has-text-centered.is-hidden-tablet.is-hidden-desktop
          span.card-content
            b 
              | {{ device.ubicacion }}
</template>

<script>
  export default {
    name: 'Card',
    props: {
      device: {
        type: Object,
        default: () => {}
      },
    }, 
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/codigosQR_Componentes/components/Card.vue